module.exports = __webpack_public_path__ + "img/KSC-2.0b3c4176.jpg";